// extracted by mini-css-extract-plugin
module.exports = {"h1":"Header_h1__Og76k"};